import { TextItemSchema } from 'cms/schemaTypes/staticPages/objects/textItem'
import Link from 'next/link'

import CustomPortableText from 'lib/sanity/richText/CustomPortableText'

import { SectionContainer } from '../landings/styles'

import styles from './CooperationContactSection.module.scss'

interface CooperationContactSectionProps {
  contactSection: {
    header: TextItemSchema
    email: string
    tel: string
  }
}

const CooperationContactSection = ({
  contactSection
}: CooperationContactSectionProps) => {
  const { header, email, tel } = contactSection

  return (
    <SectionContainer id='kontakt' $condensed className={styles.section}>
      <div className={styles.contentWrapper}>
        <CustomPortableText value={header.textField || []} />
        <span>
          <Link href={`mailto:${email}`} className={styles.link}>
            {email}
          </Link>{' '}
          <span className={styles.noWrap}>lub {tel}</span>
        </span>
      </div>
    </SectionContainer>
  )
}

export default CooperationContactSection
